import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { AuthProvider, ThemeProvider, LanguageProvider, OverlayProvider } from '@shondalai/ui-commons';
import FormSubmission from '@/pages/FormSubmission';

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 5 * 60 * 1000, // 5 minutes
    },
  },
});

function PublicApp() {
  console.log('EasyForms: PublicApp component rendering');

  const joomlaOptions = (window as any).Joomla?.getOptions?.('com_easyforms') || {};
  console.log('EasyForms: Joomla options:', joomlaOptions);

  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider
        defaultTheme="system"
        storageKey="easyforms-public-theme"
        rootSelector="#easyforms-app"
        applyToDocumentRoot={false}
      >
        <OverlayProvider containerId="easyforms-overlay-host">
          <LanguageProvider>
            <AuthProvider componentNamespace="com_easyforms" userDataKey="user">
              <div id="easyforms-overlay-host" className="ef-overlay-host" />
              <FormSubmission />
            </AuthProvider>
          </LanguageProvider>
        </OverlayProvider>
      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default PublicApp;

